// extracted by mini-css-extract-plugin
module.exports = {"button":"ButtonLinkMore_button__u58qz","icon":"ButtonLinkMore_icon__9kUph"};